import { cn } from '@evolve/common-ui';
import { getCountryCallingCode } from 'libphonenumber-js';
import React, { useEffect, useState } from 'react';
import { Country, FlagProps } from 'react-phone-number-input';
import flags from 'react-phone-number-input/flags';
import { Select } from '../select';

function FlagComponent({
  country,
  countryName,
  prefix,
}: FlagProps & { prefix: string }) {
  const Flag = flags[country];

  return (
    <div className="flex flex-row items-center gap-1 text-base">
      <span className="flex h-[20px] w-[20px] overflow-hidden rounded-md">
        {Flag && typeof Flag === 'function' ? (
          <Flag title={countryName} />
        ) : (
          <span>{country}</span>
        )}
      </span>
      <span>{prefix}</span>
    </div>
  );
}

FlagComponent.displayName = 'FlagComponent';

function getShownFlags() {
  const shownFlags: any[] = [];
  for (const [key, value] of Object.entries(flags)) {
    try {
      const prefix = getCountryCallingCode(key as Country);
      if (prefix && prefix !== '1') {
        shownFlags.push({
          label: (
            <FlagComponent
              key={key}
              country={key as Country}
              countryName={value as unknown as string}
              prefix={`+${prefix}`}
            />
          ),
          value: `+${prefix}`,
        });
      }
    } catch (e) {
      //console.warn(e);
    }
  }
  return shownFlags;
}

const PhonePrefixInput = (props: any) => {
  const shownFlags = getShownFlags();

  return (
    <Select
      {...props}
      options={shownFlags}
      placeholder="Indicativo"
      isDisabled={props.disabled}
      controlClassname="!border-2 !shadow-none w-24"
      indicatorSeparatorClassname="!hidden"
      dropdownIndicatorClassname="!hidden !pl-0 !ml-0"
      value={
        props.value?.value
          ? shownFlags.find((flag) => flag.value === props.value.value)
          : null
      }
    />
  );
};

export function PhoneInput(props: any) {
  const { onChange, value } = props;
  const [prefix, setPrefix] = useState<string>('');
  const [number, setNumber] = useState<string>('');

  useEffect(() => {
    if (value && value.startsWith('+')) {
      const [prefix, ...rest] = value.split(' ');
      setPrefix(prefix ?? '+351');
      setNumber(rest.join(' ') || '');
    } else {
      setPrefix('+351');
      setNumber(value ?? '');
    }
  }, [value]);

  useEffect(() => {
    if (prefix && number) {
      onChange(`${prefix} ${number}`);
    }
  }, [prefix, number]);

  return (
    <div className="flex flex-row">
      <PhonePrefixInput
        {...props}
        value={{ value: prefix, label: prefix }}
        onChange={(option: any) => setPrefix(option?.value)}
      />
      <input
        className={cn(
          'border-evolve-primary focus-visible:!border-evolve-highlight-50 w-full border-2 border-l-0 px-2 text-sm focus-visible:outline-none',
          props.className,
          { 'bg-evolve-secondary': props.disabled },
          {
            '!border-red-500 focus-visible:!border-red-500': props.error,
          },
        )}
        {...props}
        value={number}
        onChange={(e) => setNumber(e.target.value)}
        placeholder="Número"
      />
    </div>
  );
}
